export const LoanFinancer_REQ_LIST_REQUEST = "LoanFinancer_REQ_LIST_REQUEST";
export const LoanFinancer_REQ_LIST_SUCCESS = "LoanFinancer_REQ_LIST_SUCCESS";
export const LoanFinancer_REQ_LIST_FAIL = "LoanFinancer_REQ_LIST_FAIL";

export const GetDialysisService_REQ_LIST_REQUEST = "GetDialysisService_REQ_LIST_REQUEST";
export const GetDialysisService_REQ_LIST_SUCCESS = "GetDialysisService_REQ_LIST_SUCCESS";
export const GetDialysisService_REQ_LIST_FAIL = "GetDialysisService_REQ_LIST_FAIL";